import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/auth/AuthProvider";
import { Loader2, AlertCircle } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);
  const { refresh } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;

    // clean hash from URL
    if (window.history?.replaceState) {
      window.history.replaceState(null, "", window.location.pathname);
    }

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        await api.post("/auth/session", { session_id: sessionId });
        await refresh();
        navigate("/admin", { replace: true });
      } catch (e) {
        const detail = e?.response?.data?.detail || "Authentification refusée.";
        setError(detail);
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-stone-50 px-6">
      <div data-testid="auth-callback" className="max-w-md text-center">
        {error ? (
          <div>
            <div className="mx-auto mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-red-50 text-red-600">
              <AlertCircle className="h-5 w-5" strokeWidth={1.5} />
            </div>
            <h1 className="text-2xl font-light tracking-tight text-stone-900">Accès refusé</h1>
            <p className="mt-3 text-sm text-stone-600">{error}</p>
            <button
              onClick={() => navigate("/login", { replace: true })}
              className="mt-6 rounded-full border border-stone-300 px-5 py-2 text-sm text-stone-700 hover:bg-stone-100"
              data-testid="auth-callback-retry"
            >
              Réessayer
            </button>
          </div>
        ) : (
          <div className="flex flex-col items-center gap-3 text-stone-500">
            <Loader2 className="h-5 w-5 animate-spin" strokeWidth={1.5} />
            <p className="text-sm">Connexion en cours…</p>
          </div>
        )}
      </div>
    </div>
  );
}
